module.exports = __webpack_public_path__ + "gamechanger-180d2f951e1c15082fc8.png";